import React, { useEffect, useState, useRef } from 'react';
interface SpotlightProps {
  className?: string;
  /** Radius of the spotlight in px */
  size?: number;
  /** Spotlight color (rgba) */
  color?: string;
}
/**
 * Mouse-following spotlight — a soft radial gradient that tracks the
 * cursor across the section. When the cursor isn't over the section,
 * the spotlight drifts on its own with a gentle Lissajous orbit.
 */
export function Spotlight({
  className = '',
  size = 520,
  color = 'rgba(26, 143, 212, 0.22)'
}: SpotlightProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [pos, setPos] = useState({
    x: 50,
    y: 50
  });
  const [active, setActive] = useState(false);
  const idleT = useRef(0);
  const raf = useRef(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const onMove = (e: MouseEvent) => {
      const rect = el.getBoundingClientRect();
      const x = (e.clientX - rect.left) / rect.width * 100;
      const y = (e.clientY - rect.top) / rect.height * 100;
      setPos({
        x,
        y
      });
      setActive(true);
    };
    const onLeave = () => setActive(false);
    const parent = el.parentElement;
    if (parent) {
      parent.addEventListener('mousemove', onMove);
      parent.addEventListener('mouseleave', onLeave);
    }
    // Idle drift animation
    const tick = () => {
      idleT.current += 0.005;
      if (!active) {
        const x = 50 + Math.sin(idleT.current * 1.1) * 25;
        const y = 50 + Math.cos(idleT.current * 0.7) * 20;
        setPos({
          x,
          y
        });
      }
      raf.current = requestAnimationFrame(tick);
    };
    tick();
    return () => {
      if (parent) {
        parent.removeEventListener('mousemove', onMove);
        parent.removeEventListener('mouseleave', onLeave);
      }
      cancelAnimationFrame(raf.current);
    };
  }, [active]);
  return <div ref={ref} className={`absolute inset-0 pointer-events-none transition-opacity duration-500 ${className}`} style={{
    background: `radial-gradient(${size}px circle at ${pos.x}% ${pos.y}%, ${color}, transparent 60%)`
  }} data-id="element-235" />;
}